export default __webpack_public_path__ + "static/media/gs.73c5c198.jpg";